import React from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Approach from './components/Approach';
import Services from './components/Services';
import Capabilities from './components/Capabilities';
import Pricing from './components/Pricing';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <Approach />
        <Services />
        <Capabilities />
        <Pricing />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
